import { themeGet, themeGetColor } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
const containerOverlayStyle = css `
  z-index: 1;
  position: absolute;
  backdrop-filter: blur(0.2rem);
  background-color: ${themeGetColor('primary.50', 0.56)};
`;
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${themeGet('spacing.lg')};
  width: 100%;
  height: 100%;
  padding: ${themeGet('spacing.2xl')};
  text-align: center;
  background-color: ${themeGet('colors.primary.50')};

  ${({ $overlay }) => $overlay && containerOverlayStyle};
`;
